import React from "react";
import { ASSETS } from "../../constants/assets";

const LOGO_CLASS =
  "h-16 w-16 object-contain grayscale opacity-80 shrink-0";

const PARTNERS = ASSETS.partners;

function LogoSet(): React.ReactElement {
  return (
    <div className="w-1/2 shrink-0 flex items-center justify-between gap-4 px-4 md:px-12">
      {PARTNERS.map((src, i) => (
        <img
          key={i}
          src={src}
          alt=""
          className={LOGO_CLASS}
          aria-hidden
        />
      ))}
    </div>
  );
}

export function PartnerLogos(): React.ReactElement {
  return (
    <section className="border border-black/15 rounded-lg shadow-lg py-10 md:py-[140px] overflow-hidden">
      <div className="w-full overflow-hidden">
        <div className="flex w-[200%] animate-marquee">
          <LogoSet />
          <LogoSet />
        </div>
      </div>
    </section>
  );
}

export default PartnerLogos;
